import { render, staticRenderFns } from "./UtgiftskategoriListItem.vue?vue&type=template&id=da47f234&"
import script from "./UtgiftskategoriListItem.vue?vue&type=script&lang=js&"
export * from "./UtgiftskategoriListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports